/*
 * EMEDEMORA · El video de sections/emd-video-texto.liquid.
 * - No se baja nada hasta que la sección está por entrar a la pantalla (el video va con preload="none"): mientras, se
 *   ve su foto de portada.
 * - Corre sin sonido y en bucle mientras se ve; se pausa al salir de la pantalla o al cambiar de pestaña.
 * - El botón de la esquina lo pausa y lo vuelve a correr. Arranca solo aunque el equipo pida menos movimiento (Mario,
 *   2026-10-19: «que se reproduzcan automáticamente… tipo loop»); si el navegador no deja (el ahorro de batería del
 *   iPhone), el botón queda en «reproducir».
 * - El video aparece encima de la foto solo cuando ya está corriendo (clase is-reproduciendo).
 */
if (!customElements.get('emd-video-auto')) {
  customElements.define(
    'emd-video-auto',
    class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.boton = this.querySelector('.emd-vt-pausa');
        this.detenido = false;
        this.visible = false;
        this.alCorrer = () => this.classList.add('is-reproduciendo');
        this.alCambiar = () => this.actualizar();
        this.alTocar = () => {
          this.detenido = !this.detenido;
          this.actualizar();
        };
        this.video.addEventListener('playing', this.alCorrer);
        this.boton?.addEventListener('click', this.alTocar);
        document.addEventListener('visibilitychange', this.alCambiar);
        this.observador = new IntersectionObserver(
          (entradas) => {
            this.visible = entradas[entradas.length - 1].isIntersecting;
            this.actualizar();
          },
          { rootMargin: '240px 0px' }
        );
        this.observador.observe(this);
        this.actualizar();
      }

      disconnectedCallback() {
        this.observador?.disconnect();
        document.removeEventListener('visibilitychange', this.alCambiar);
        this.video?.removeEventListener('playing', this.alCorrer);
        this.boton?.removeEventListener('click', this.alTocar);
      }

      actualizar() {
        const correr = this.visible && !this.detenido && document.visibilityState === 'visible';
        if (correr && this.video.paused) {
          this.video.preload = 'auto';
          const intento = this.video.play();
          if (intento)
            intento.catch((error) => {
              if (error && error.name === 'NotAllowedError') {
                this.detenido = true;
                this.actualizar();
              }
            });
        } else if (!correr && !this.video.paused) {
          this.video.pause();
        }
        if (this.boton) {
          this.boton.classList.toggle('is-detenido', this.detenido);
          this.boton.setAttribute('aria-label', this.detenido ? this.boton.dataset.reproducir : this.boton.dataset.pausar);
        }
      }
    }
  );
}
